import { render } from "./buffer.vue?vue&type=template&id=5474e59c&scoped=true&ts=true"
import script from "./buffer.vue?vue&type=script&lang=ts"
export * from "./buffer.vue?vue&type=script&lang=ts"

import "./buffer.vue?vue&type=style&index=0&id=5474e59c&lang=less&scoped=true"

import exportComponent from "/home/npm/produce/project/yuanYaExam/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5474e59c"]])

export default __exports__